
<h1 mat-dialog-title>{{ 'case_number_dialog.title' | translate | titlecase }}</h1>

<div mat-dialog-content>

    <div class="row">
        <div class="col-sm-10">
            <mat-form-field class="full-width">
                <mat-label>{{ data.case.trans.office | translate }}</mat-label>
                <mat-select id="{{idPrefix}}input_select.office"
                            [(ngModel)]="selectedOffice"
                            (ngModelChange)="onOfficeChange()">
                    <mat-option *ngFor="let office of data.offices; let idx = index"
                                id="{{idPrefix}}input_select.office.item_{{idx}}"
                                [value]="office">
                        {{ office.actionListDisplayName | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-2"></div>
    </div>

    <div class="row" *ngIf="freeText1">
        <div class="col-sm-10">
            <mat-form-field class="full-width">
                <mat-label>{{ freeText1.trans | translate }}</mat-label>
                <input id="{{idPrefix}}input_text.{{freeText1.key}}"
                       type="text" matInput
                       [(ngModel)]="freeText1Value">
            </mat-form-field>
        </div>

        <div class="col-sm-2"></div>
    </div>

    <div class="row" *ngIf="freeText2">
        <div class="col-sm-10">
            <mat-form-field class="full-width">
                <mat-label>{{ freeText2.trans | translate }}</mat-label>
                <input id="{{idPrefix}}input_text.{{freeText2.key}}"
                       type="text" matInput
                       [(ngModel)]="freeText2Value">
            </mat-form-field>
        </div>

        <div class="col-sm-2"></div>
    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.ok"
                mat-raised-button class="full-width" color="accent"
                (click)="accept()">
            {{ 'common.btn.ok' | translate }}
        </button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.cancel"
                mat-stroked-button
                color="primary"
                class="full-width"
                (click)="close()">
            {{ 'common.btn.cancel' | translate }}
        </button>
    </div>

</div>
